<script setup lang="ts">

import {useCurrentWorkspaceUser} from "~/stores/spaces";
import {addPlanToEnvironment} from "~/calls/subscription";
import {PRO_PLAN_TYPE} from "~/types/subscription.types";

const {isOwner} = useCurrentWorkspaceUser()
const {workspaceId, environmentId} = useEnvironment()
const {plan} = useSubscriptionForEnvironment()
const router = useRouter();

const connections = ref(plan.value?.connections || 5)
const loading = ref(false)
const redirecting = ref(false)
const currency = ref<'USD' | 'EUR'>('USD')

const updatePlan = () => {
  loading.value = true

  const finishUrl = `/workspace/${workspaceId.value}/env/${environmentId.value}/subscription?action=buy&connections=${connections.value}&plan=Pro`
  const cancelUrl = `/workspace/${workspaceId.value}/env/${environmentId.value}/subscription?action=canceled`

  addPlanToEnvironment(
      workspaceId.value,
      environmentId.value,
      PRO_PLAN_TYPE,
      connections.value,
      window.location.origin + finishUrl,
      window.location.origin + cancelUrl,
      null,
  ).then((r) => {
    loading.value = false
    if (!r.success) return
    if (r.result?.url) {
      redirecting.value = true
      setTimeout(() => {
        window.location.href = r.result.url
      }, 2500)
    } else {
      loading.value = false
      router.push(finishUrl)
    }
  }).finally(() => {
    loading.value = false
  })

}

</script>
<template>
  <div>
    <p>
      You have chosen the AxonIQ Console Professional plan. It contains everything your need to get started seriously
      in Production.
    </p>

    <div class="my-4">
      <p class="h5">
        How many connections do you need?
      </p>
      <SubscriptionFormProConnectionChooser v-model="connections" :currency="currency" :plan-type="PRO_PLAN_TYPE"
                                            class="mt-2"/>
    </div>
    <v-alert class="my-4">
      <p>
        You already have a subscription to AxonIQ Console for another environment. The same payment method will be
        charged automatically.
      </p>
    </v-alert>
    <div class="d-flex justify-end">
      <v-btn color="primary" @click="updatePlan" :loading="loading"
             :disabled="!isOwner">
        Start your Subscription
      </v-btn>
    </div>
  </div>

</template>
